module.exports = __webpack_public_path__ + "img/student.0ba0711e.svg";